import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';
import ZoneFilter from '../ZoneFilter';
import DifficultyFilter from './DifficultyFilter';
import SunlightFilter from './SunlightFilter';
import SeasonFilter from './SeasonFilter';
import type { Zone } from '../../types/zone';

interface FiltersBarProps {
  selectedZone: Zone | null;
  onZoneChange: (zone: Zone | null) => void;
  selectedDifficulty: string | null;
  onDifficultyChange: (difficulty: string | null) => void;
  selectedSunlight: string | null;
  onSunlightChange: (sunlight: string | null) => void;
  selectedSeason: string | null;
  onSeasonChange: (season: string | null) => void;
}

export default function FiltersBar({
  selectedZone,
  onZoneChange,
  selectedDifficulty,
  onDifficultyChange,
  selectedSunlight,
  onSunlightChange,
  selectedSeason,
  onSeasonChange
}: FiltersBarProps) {
  const [showFilters, setShowFilters] = useState(false);

  const hasActiveFilters = selectedZone || selectedDifficulty || selectedSunlight || selectedSeason;

  const clearFilters = () => {
    onZoneChange(null);
    onDifficultyChange(null);
    onSunlightChange(null);
    onSeasonChange(null);
  };

  return (
    <div className="bg-white shadow-sm rounded-lg mb-6">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors"
          >
            <Filter className="h-5 w-5" />
            <span className="font-medium">Filters</span>
            {hasActiveFilters && (
              <span className="bg-primary-100 text-primary-700 text-xs font-medium px-2 py-0.5 rounded-full">
                Active
              </span>
            )}
          </button>
          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
            >
              <X className="h-4 w-4" />
              Clear all
            </button>
          )}
        </div>

        {showFilters && (
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <ZoneFilter 
              selectedZone={selectedZone} 
              onZoneChange={onZoneChange}
            />
            <DifficultyFilter
              selectedDifficulty={selectedDifficulty}
              onDifficultyChange={onDifficultyChange}
            />
            <SunlightFilter
              selectedSunlight={selectedSunlight}
              onSunlightChange={onSunlightChange}
            />
            <SeasonFilter
              selectedSeason={selectedSeason}
              onSeasonChange={onSeasonChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}